export const isMaize = product => {
  return product && product.cropId === '41d89034-7ef5-463b-bdd6-1820234ea708'
}
